export default __webpack_public_path__ + "static/media/person.1983271b.png";